var _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImproveBottomLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.4007,
    cy: 40.7054,
    r: 39.4807,
    fill: "white",
    stroke: "url(#paint0_linear_219_10374)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4005 17.813L59.8586 29.2586V52.1506L40.4005 63.5968L20.9424 52.1506V29.2586L40.4005 17.813ZM42.4005 38.4159C42.4005 37.3113 41.5051 36.4159 40.4005 36.4159C39.2959 36.4159 38.4005 37.3113 38.4005 38.4159V47.5727C38.4005 48.6772 39.2959 49.5727 40.4005 49.5727C41.5051 49.5727 42.4005 48.6772 42.4005 47.5727V38.4159ZM49.5573 31.8375C50.6618 31.8375 51.5573 32.7329 51.5573 33.8375V47.5727C51.5573 48.6772 50.6618 49.5727 49.5573 49.5727C48.4527 49.5727 47.5573 48.6772 47.5573 47.5727V33.8375C47.5573 32.7329 48.4527 31.8375 49.5573 31.8375ZM33.2437 42.9943C33.2437 41.8897 32.3483 40.9943 31.2437 40.9943C30.1392 40.9943 29.2437 41.8897 29.2437 42.9943V47.5727C29.2437 48.6772 30.1392 49.5727 31.2437 49.5727C32.3483 49.5727 33.2437 48.6772 33.2437 47.5727V42.9943Z",
    fill: "url(#paint1_linear_219_10374)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_219_10374",
    x1: 40.4007,
    y1: 0.724609,
    x2: 40.4007,
    y2: 80.6861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_219_10374",
    x1: 40.4005,
    y1: 17.813,
    x2: 40.4005,
    y2: 63.5968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImproveBottomLine);
export default __webpack_public_path__ + "static/media/ImproveBottomLine.058e8a830e7ac235e7fb0ef9676f418e.svg";
export { ForwardRef as ReactComponent };